<script>
import { componentStore } from "@common/componentStore/componentStore";

const componentTestDataConfig = {
    cId: 'componentTestData',
    cType: "componentTestData",
    cTitle: "Component Test Data",
    cTemplate: `<div class="component-test-data">
                    <div v-if="!testDataListEnabled" class="test-data-list-controls">
                            <div><control name="TEST_DATA_LIST" :items="testDataKeys"></control></div>
                            <div><control name="TEST_DATA_ACTIONS"></control></div>
                    </div>
                    <div v-show="selectedTestData || isNew">
                        <div class="col-md-12">
                            <control name="TEST_DATA_KEY" :disabled="!isNew"></control>
                            <control name="TEST_DATA_JSON"></control>
                            <control name="COPY_CURRENT_STATE" v-if="!testDataListEnabled"></control>
                        </div>
                        <div class="col-md-6 fl"><control name="TEST_DATA_SAVE" :disabled="isActionsDisabled('save')"></control></div>
                        <div class="col-md-6 fl" v-if="!testDataListEnabled"><control name="TEST_DATA_APPLY" :disabled="isActionsDisabled('apply')"></control></div>
                        <div class="col-md-6 fl" v-if="testDataListEnabled"><control name="TEST_DATA_DELETE"></control></div>
                        <div v-show="false">
                            <br><br><br>
                            <div class="col-md-10 fl"><control name="TEST_DATA_COMMAND"></control></div>
                            <div class="col-md-2 fl"><control name="TEST_DATA_COMMAND_RUN"></control></div>
                        </div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'TEST_DATA_LIST',
            type: "dropdown",
            placeholder: "Select Test Data",
            onchange: "getTestData",
            popupHeight: "220px",
            fields: { text: 'text', value: 'value' },
        },
        {
            name: 'TEST_DATA_ACTIONS',
            type: 'splitbutton',
            label: 'New',
            onclick: 'testDataActions',
            onselect: 'testDataActions',
            cssClass: 'e-block preview-link',
            items: [
                { text: 'Delete', value: 'delete' }
            ]
        },
        {
            name: 'TEST_DATA_KEY',
            type: "string",
            placeholder: "Test Dataset ID"
        },
        {
            name: 'TEST_DATA_JSON',
            type: "text",
            placeholder: "Test Data State",
            rows: 5
        },
        {
            name: 'TEST_DATA_COMMAND',
            type: "string",
            placeholder: "Test Data Action"
        },
        {
            name: 'TEST_DATA_COMMAND_RUN',
            type: "button",
            label: 'Execute',
            onclick: 'executeCommand',
            cssClass: 'e-block e-outline e-success'
        },
        {
            name: 'COPY_CURRENT_STATE',
            type: 'button',
            label: 'Copy Current State',
            onclick: 'copyState',
            cssClass: 'e-block e-outline e-info'
        },
        {
            name: 'TEST_DATA_SAVE',
            type: 'button',
            label: 'Save',
            onclick: 'saveTestData',
            cssClass: 'e-block e-info'
        },
        {
            name: 'TEST_DATA_APPLY',
            type: 'button',
            label: 'Apply to Preview',
            onclick: 'applyTestData',
            cssClass: 'e-block e-success'
        },
        {
            name: 'TEST_DATA_DELETE',
            type: 'button',
            label: 'Delete',
            onclick: 'deleteTestData',
            cssClass: 'e-block e-warning'
        },
    ],
    layoutDatamap: [
        {
            "property": "testDataSaved", "from": "componentTestData", "to": "thisStore", "as": "testDataSaved"
        },
    ]
};

const componentTestDataCmp = {
    name: 'componentTestData',
    preInitControls: true,
    props: {
        testDataListEnabled: {
            type: Boolean,
            default: false
        },
        componentId: {
            default: false
        },
        selectedTestData: {
            default: false
        },
        testStoreId: {
            default: false
        },
        isNew: {
            default: false
        }
    },
    data() {
        return {
            component: null,
            componentType: null,
            testDataKeys: [],
            testDataSaved: false
        };
    },
    methods: {
        async onLoad() {
            if (this.componentId) {
                this.component = await componentStore.getConfig(this.componentId);
            }
            if (typeof errorHandler !== 'undefined' && errorHandler.get('isRepeat')) {
                this.applyTestData();
            }
        },
        onMappedDataUpdate() {
            this.onPropsUpdate();
        },
        async onPropsUpdate() {
            let getParams = library.urlParser.getParams();
            if (getParams && getParams['repeater'] && getParams['instance']) {
                return;
            }
            this.controls['TEST_DATA_KEY'].value = '';
            this.controls['TEST_DATA_JSON'].value = '';
            if (this.componentId) {
                let componentConfig = await componentStore.getConfig(this.componentId);
                this.componentType = componentConfig.cType;
                if (this.componentType) {
                    this.getTestDataKeys();
                }
            }
            if (this.selectedTestData) {
                this.getTestData();
            }
        },
        async getTestDataKeys() {
            if (this.testDataListEnabled) return;
            componentStore.getTestDataKeys().then((data) => {
                if (!Array.isArray(data)) return;
                let dataKeys = [];
                for (let i in data) {
                    if (i === 'length' || data[i].cType !== this.componentType) continue;
                    dataKeys.push({
                        'text': data[i]['key'],
                        'value': data[i]['key']
                    });
                }
                this.testDataKeys = dataKeys;
            });
        },
        isActionsDisabled(control) {
            if (control === 'save') {
                return !this.controls['TEST_DATA_KEY'].value || !this.controls['TEST_DATA_JSON'].value;
            }
            return !this.controls['TEST_DATA_JSON'].value;
        },
        getTestData(testData) {
            if (testData && testData.value) {
                this.selectedTestData = testData.value;
                this.isNew = false;
            }
            if (!this.selectedTestData) return;
            this.sDs.post('sds_getTestData', this.selectedTestData).then((response) => {
                if (response.status !== 'success') return;
                this.controls['TEST_DATA_KEY'].value = library.cloneObj(this.selectedTestData);
                for (let i in response.data[this.selectedTestData]) {
                    if (i === 'length') continue;
                    if (!this.componentType) this.componentType = i;
                    this.controls['TEST_DATA_JSON'].value = response.data[this.selectedTestData][i];
                }
            });
        },
        copyState() {
            if (Array.isArray(this.storeId) && this.storeId[0] && this.$store.state[this.storeId[0]] && this.$store.state[this.storeId[0]].componentPreview && !this.$store.state[this.storeId[0]].componentPreview.previewEnabled) {
                this.$store.state[this.storeId[0]].componentPreview.previewEnabled = true;
                setTimeout(() => {
                    this.copyState();
                }, 1000); // NOSONAR
            } else {
                let finalStorePath = this.componentId;
                if (this.testStoreId) finalStorePath += "__" + this.testStoreId;
                if (this.$store.state[this.storeId[0]] && this.$store.state[this.storeId[0]][finalStorePath]) {
                    let state = library.cloneObj(this.$store.state[this.storeId[0]][finalStorePath]);
                    for (let i in state) {
                        if (i === 'length') continue;
                        delete state['prop' + library.capitalizeFirstLetter(i)];
                    }
                    // test data state should not contain component settings
                    delete state['settings'];
                    delete state['config'];
                    delete state['cId'];
                    delete state['controls'];
                    delete state['cType'];
                    let json = JSON.stringify(state, false, 2); // NOSONAR
                    this.controls['TEST_DATA_JSON'].value = library.cloneObj(json);
                }
            }
        },
        saveTestData() {
            let testDataKey = this.controls['TEST_DATA_KEY'].value;
            let testDataJson = this.controls['TEST_DATA_JSON'].value;
            if (testDataKey && testDataJson && this.componentType) {
                if (library.isJson(testDataJson)) {
                    this.testDataSaved = false;
                    this.sDs.post('sds_setTestData', testDataKey, this.componentType, testDataJson).then((response) => {
                        if (response.status === 'success') {
                            this.getTestDataKeys();
                            this.testDataSaved = true;
                            library.showToast('Test Data saved', { timeout: 10 });
                        }
                    });
                } else {
                    library.showToast((this.controls['TEST_DATA_JSON'].label ? this.controls['TEST_DATA_JSON'].label : 'Test data JSON object') + ' is not valid', { timeout: 10, type: 'warning' });
                }
            }
        },
        deleteTestData() {
            let selectedTestData = library.cloneObj(this.controls['TEST_DATA_LIST'].value) || this.selectedTestData;
            if (selectedTestData) {
                library.showDialog("Are you sure you want to delete this Test Data?",
                    () => {
                        this.sDs.post('sds_deleteTestData', selectedTestData).then((response) => {
                            if (response.status === 'success') {
                                this.selectedTestData = false;
                                this.getTestDataKeys();
                                library.showToast('Test Data deleted', { timeout: 10 });
                            }
                        });
                    },
                    false,
                    {
                        title: "Confirm to Continue"
                    });
            }
        },
        newTestData() {
            this.selectedTestData = false;
            this.controls['TEST_DATA_LIST'].value = null;
            this.controls['TEST_DATA_KEY'].value = '';
            this.controls['TEST_DATA_JSON'].value = '';
            this.isNew = true;
        },
        async applyTestData() {
            let setPropData = (propData) => {
                // Set mappedProps for props not handled by componentStore
                if (propData) {
                    let currMappedProps = library.cloneObj(this.$store.state[this.storeId[0]]['componentPreview'].mappedProps);
                    this.$store.state[this.storeId[0]]['componentPreview'].mappedProps = false;
                    this.$store.state[this.storeId[0]]['componentPreview'].mappedProps = {
                        ...currMappedProps,
                        ...propData,
                    };
                }
            };
            const mergeStates = (iStorePath, testState) => {
                delete testState.propTestData;
                let state = {};
                for (let i in testState) {
                    if (i === 'length') continue;
                    let added = false;
                    if (this.$store.state[this.storeId[0]][iStorePath]['prop' + library.capitalizeFirstLetter(i)]) {
                        state['prop' + library.capitalizeFirstLetter(i)] = library.cloneObj(testState[i]);
                        added = true;
                    }
                    if (this.$store.state[this.storeId[0]][iStorePath]['data' + library.capitalizeFirstLetter(i)]) {
                        state['data' + library.capitalizeFirstLetter(i)] = library.cloneObj(testState[i]);
                        added = true;
                    }
                    if (!added) {
                        state[i] = library.cloneObj(testState[i]);
                    }
                }
                // let mergedState = {
                //     ...this.$store.state[this.storeId[0]][iStorePath],
                //     ...state
                // };
                let interval = setInterval(() => {
                    if (typeof this.$store.state[this.storeId[0]][iStorePath] !== 'undefined') {
                        clearInterval(interval);
                        // this.$store.state[this.storeId[0]][iStorePath] = mergedState;
                        for (let prop in state) {
                            if (prop === 'length') continue;
                            this.$store.state[this.storeId[0]][iStorePath][prop] = state[prop];
                        }
                    }
                }, 500); // NOSONAR
            };
            if (Array.isArray(this.storeId) && this.storeId[0] && this.$store.state[this.storeId[0]] && this.$store.state[this.storeId[0]].componentPreview && !this.$store.state[this.storeId[0]].componentPreview.previewEnabled) {
                this.$store.state[this.storeId[0]].componentPreview.previewEnabled = true;
                setTimeout(() => {
                    this.applyTestData();
                }, 1000); // NOSONAR
            } else {
                // Check for test data
                await library.timeout(500); // NOSONAR
                let testState = library.isJson(this.controls['TEST_DATA_JSON'].value)
                    ? JSON.parse(this.controls['TEST_DATA_JSON'].value)
                    : false;
                if (!testState) {
                    library.showToast((this.controls['TEST_DATA_JSON'].label ? this.controls['TEST_DATA_JSON'].label : 'Test data JSON object') + ' is not valid', { timeout: 10, type: 'warning' });
                    return;
                }
                // Set prop data that is not in vuex stores
                if (testState.propTestData) setPropData(testState.propTestData);
                // Set store data
                let finalStorePath = this.componentId;
                if (this.testStoreId) finalStorePath += "__" + this.testStoreId;
                if (this.$store.state[this.storeId[0]] && this.$store.state[this.storeId[0]][finalStorePath]) {
                    mergeStates(finalStorePath, testState);
                }
            }
        },
        testDataActions: function (extraCommand) {
            if (extraCommand.item && extraCommand.item.value) {
                switch (extraCommand.item.value) {
                    case 'delete':
                        this.deleteTestData();
                        break;
                    default:
                        break;
                }
            } else {
                this.newTestData();
            }
        },
        executeCommand: async function () {
            if (Array.isArray(this.storeId) && this.storeId[0] && this.$store.state[this.storeId[0]] && this.$store.state[this.storeId[0]].componentPreview && !this.$store.state[this.storeId[0]].componentPreview.previewEnabled) {
                this.$store.state[this.storeId[0]].componentPreview.previewEnabled = true;
                setTimeout(() => {
                    this.executeCommand();
                }, 1000); // NOSONAR
            } else {
                await library.timeout(500); // NOSONAR
                let testCommand = this.controls['TEST_DATA_COMMAND'].value;
                if (!testCommand) {
                    return;
                }
                // Set store data
                let finalStorePath = this.componentId;
                if (this.testStoreId) finalStorePath += "__" + this.testStoreId;
                if (this.$store.state[this.storeId[0]] && this.$store.state[this.storeId[0]][finalStorePath]) {
                    this.$store.state[this.storeId[0]][finalStorePath].executeCommand = testCommand;
                }
            }
        }
    }
};

componentStore.initComponent(componentTestDataCmp, componentTestDataConfig);
export { componentTestDataConfig, componentTestDataCmp };
export default componentTestDataCmp;
</script>

<style>
    .test-data-list-controls {
        display: flex;
        width: 100%;
    }
    .test-data-list-controls div + div{
        flex-shrink: 2;
    }
    .component-test-data .e-split-btn-wrapper {
        margin-top: 6px;
        margin-left: 10px;
    }
</style>
